import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignTotalPagesCountReducer = (state: DesignState, action: PayloadAction<number|undefined>) => {
  state.totalPagesCount = action.payload;
};

export default setDesignTotalPagesCountReducer;
